(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tec-scripts"] && !Shopify.designMode) return;
  try {
    (()=>{const menuButtons=[...document.querySelectorAll('[data-menu-toggle]')];
const shopMenu=document.querySelector('#shop-menu');
const header=document.querySelector('.site-header');
let menuOpener=null;
function closeShopMenu(returnFocus=false){
 if(!shopMenu)return;
 shopMenu.hidden=true;
 menuButtons.forEach(button=>{button.setAttribute('aria-expanded','false');if(button.classList.contains('menu-toggle'))button.setAttribute('aria-label','Open shop menu');});
 if(returnFocus)menuOpener?.focus();
}
menuButtons.forEach(button=>button.addEventListener('click',()=>{
 const opening=shopMenu.hidden;
 shopMenu.hidden=!opening;
 menuButtons.forEach(item=>{item.setAttribute('aria-expanded',String(opening));if(item.classList.contains('menu-toggle'))item.setAttribute('aria-label',opening?'Close shop menu':'Open shop menu');});
 menuOpener=button;
}));
document.addEventListener('keydown',event=>{if(event.key==='Escape'&&shopMenu&&!shopMenu.hidden)closeShopMenu(true);});
document.addEventListener('click',event=>{if(header&&!header.contains(event.target))closeShopMenu();});
header?.addEventListener('focusout',event=>{if(event.relatedTarget&&!header.contains(event.relatedTarget))closeShopMenu();});
shopMenu?.addEventListener('click',event=>{if(event.target.closest('a'))closeShopMenu();});
if(shopMenu){
 let menuViewportWidth=window.innerWidth;
 window.addEventListener('resize',()=>{if(window.innerWidth!==menuViewportWidth){menuViewportWidth=window.innerWidth;closeShopMenu();}});
 const current=window.location.pathname.replace(/\/$/,'');
 header.querySelectorAll('a[href]').forEach(link=>{if(link.getAttribute('href').replace(/\/$/,'')===current)link.setAttribute('aria-current','page');});
}
const motion=document.querySelector('video');
if(motion&&!matchMedia('(prefers-reduced-motion: reduce)').matches){
  const observer=new IntersectionObserver(([entry])=>{if(entry.isIntersecting){motion.play().catch(()=>{});}else{motion.pause();}},{threshold:.35});
  observer.observe(motion);
}

const partnerForm=document.querySelector('#partner-form');
if(partnerForm){
 const ready=document.querySelector('#partner-email-ready');
 const status=document.querySelector('#partner-status');
 const openEmail=document.querySelector('#partner-open-email');
 const copyButton=document.querySelector('#partner-copy');
 const fallback=document.querySelector('#partner-copy-fallback');
 const draft=document.querySelector('#partner-draft');
 let inquiryText='';
 partnerForm.addEventListener('input',()=>{
  ready.hidden=true;
  fallback.hidden=true;
  inquiryText='';
  draft.value='';
 });
 partnerForm.addEventListener('submit',event=>{
  event.preventDefault();
  if(!partnerForm.reportValidity())return;
  const fields=new FormData(partnerForm);
  const get=name=>String(fields.get(name)||'').trim();
  const subject='TEC partnership inquiry — '+get('business').replace(/[\r\n]+/g,' ').slice(0,100);
  const body=[
   'Hello TEC Products,',
   '',
   'I would like to discuss a partnership.',
   '',
   'Name: '+get('name'),
   'Email: '+get('email'),
   'Business: '+get('business'),
   'Interest: '+get('interest'),
   '',
   get('message')
  ].join('\r\n').trim();
  inquiryText='To: info@tecproducts.com\r\nSubject: '+subject+'\r\n\r\n'+body;
  const mailto='mailto:info@tecproducts.com?subject='+encodeURIComponent(subject)+'&body='+encodeURIComponent(body);
  openEmail.href=mailto;
  draft.value=inquiryText;
  ready.hidden=false;
  fallback.hidden=true;
  status.textContent='Your inquiry is ready. Send it from your email app to complete your request. If the app didn’t open, use the link below or copy your inquiry.';
  window.location.href=mailto;
 });
 copyButton.addEventListener('click',async()=>{
  if(!inquiryText)return;
  try{
   await navigator.clipboard.writeText(inquiryText);
   status.textContent='Inquiry copied. Paste it into an email to info@tecproducts.com and send it to contact our team.';
  }catch{
   fallback.hidden=false;
   draft.focus();
   draft.select();
   status.textContent='Copy the text below and send it to info@tecproducts.com. Your inquiry has not been sent yet.';
  }
 });
}
})();
/* Bend the photographed neck along an arc, controlled only at the outlet tip. */
(() => {
  const stage = document.querySelector('[data-funnel]');
  if (!stage) return;
  const control = stage.querySelector('.funnel-play');
  const canvas = control.querySelector('canvas');
  const photo = stage.querySelector('.funnel-static');
  const hint = stage.querySelector('.funnel-hint');
  const resetButton = stage.querySelector('.funnel-reset');
  const handle = stage.querySelector('.funnel-handle');
  const gl = canvas.getContext('webgl', { alpha: true, antialias: true, premultipliedAlpha: false });
  const context2d = !gl ? canvas.getContext('2d') : null;
  if (!gl && !context2d) return; // Keep the original photograph when WebGL is unavailable.

  // Trace the centerline of the existing bent photograph. The cup and handle
  // remain rigid; the ribs follow a constant-length arc and the outlet rotates
  // with its tangent. This avoids stretching the spout sideways like a shear.
  const neck = { x: 0.553, y: 0.512, length: 0.333, restAngle: -0.93 };
  const radius = -neck.length / neck.restAngle;
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  function frame(distance, angle) {
    const s = Math.min(distance, neck.length);
    const turn = angle * s / neck.length;
    const x = Math.abs(angle) < 0.00001 ? 0 : neck.length * (1 - Math.cos(turn)) / angle;
    const y = Math.abs(angle) < 0.00001 ? s : neck.length * Math.sin(turn) / angle;
    const tail = Math.max(0, distance - neck.length);
    return { x: x + tail * Math.sin(turn), y: y + tail * Math.cos(turn), nx: Math.cos(turn), ny: -Math.sin(turn) };
  }
  const originalEnd = frame(neck.length, neck.restAngle);
  function rigPoint(x, y) {
    if (y <= neck.y) return { fixed: true, x: x - neck.x, y: y - neck.y };
    const dx = x - neck.x + radius, dy = y - neck.y;
    const turn = Math.atan2(dy, dx);
    if (turn < -neck.restAngle) return { s: radius * turn, width: Math.hypot(dx, dy) - radius };
    const ex = x - neck.x - originalEnd.x, ey = y - neck.y - originalEnd.y;
    return {
      s: neck.length + ex * Math.sin(neck.restAngle) + ey * Math.cos(neck.restAngle),
      width: ex * originalEnd.nx + ey * originalEnd.ny
    };
  }
  function position(point, angle) {
    if (point.fixed) return point;
    const center = frame(point.s, angle);
    return { x: center.x + point.width * center.nx, y: center.y + point.width * center.ny };
  }
  const tip = rigPoint(0.19, 0.954);
  const maxAngle = 3 * Math.PI / 4;
  let bend = 0, pointer = null, ready = false, pendingFrame = null;

  const vertex = `
    attribute vec2 a_uv;
    attribute vec2 a_position;
    varying vec2 v_uv;
    uniform vec2 u_scale;
    uniform vec2 u_origin;
    void main() {
      v_uv = a_uv;
      gl_Position = vec4(u_origin.x + a_position.x * u_scale.x,
                         u_origin.y - a_position.y * u_scale.y, 0.0, 1.0);
    }
  `;
  const fragment = `
    precision mediump float;
    varying vec2 v_uv;
    uniform sampler2D u_photo;
    void main() {
      vec4 pixel = texture2D(u_photo, v_uv);
      if (pixel.a < 0.01) discard;
      gl_FragColor = pixel;
    }
  `;
  const compile = (type, source) => {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) throw new Error('Funnel shader unavailable');
    return shader;
  };
  let program;
  if (gl) {
  try {
    program = gl.createProgram();
    const shaders = [compile(gl.VERTEX_SHADER, vertex), compile(gl.FRAGMENT_SHADER, fragment)];
    shaders.forEach(shader => gl.attachShader(program, shader));
    gl.linkProgram(program);
    shaders.forEach(shader => gl.deleteShader(shader));
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) return;
    gl.useProgram(program);
  } catch { return; }
  }

  const uv = [], rig = [], indices = [], divisions = gl ? 96 : 28;
  for (let y = 0; y <= divisions; y++) {
    for (let x = 0; x <= divisions; x++) {
      uv.push(x / divisions, y / divisions);
      rig.push(rigPoint(x / divisions, y / divisions));
      if (x < divisions && y < divisions) {
        const i = y * (divisions + 1) + x;
        indices.push(i, i + 1, i + divisions + 1, i + divisions + 1, i + 1, i + divisions + 2);
      }
    }
  }
  const positions = new Float32Array(uv.length);
  function attribute(name, data, usage) {
    const buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(gl.ARRAY_BUFFER, data, usage);
    const location = gl.getAttribLocation(program, name);
    gl.enableVertexAttribArray(location);
    gl.vertexAttribPointer(location, 2, gl.FLOAT, false, 0, 0);
    return buffer;
  }
  let positionBuffer, uniforms;
  if (gl) {
  attribute('a_uv', new Float32Array(uv), gl.STATIC_DRAW);
  positionBuffer = attribute('a_position', positions, gl.DYNAMIC_DRAW);
  gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, gl.createBuffer());
  gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices), gl.STATIC_DRAW);
  uniforms = Object.fromEntries(['u_scale', 'u_origin'].map(name => [name, gl.getUniformLocation(program, name)]));
  gl.bindTexture(gl.TEXTURE_2D, gl.createTexture());
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);

  }
  function geometry() {
    const rect = control.getBoundingClientRect();
    // Reserve room for the entire left-to-right sweep and the touch target.
    const size = Math.max(0, Math.min((rect.width - 56) / 1.1, (rect.height - 40) / 1.14));
    return { rect, size, originX: rect.width / 2, originY: (rect.height - 1.13 * size) / 2 + 0.515 * size };
  }
  function draw() {
    if (!ready) return;
    const { rect, size, originX, originY } = geometry();
    if (!size) return;
    const ratio = Math.min(window.devicePixelRatio || 1, 2);
    const width = Math.max(1, Math.round(rect.width * ratio));
    const height = Math.max(1, Math.round(rect.height * ratio));
    if (canvas.width !== width || canvas.height !== height) {
      canvas.width = width; canvas.height = height;
      if (gl) gl.viewport(0, 0, width, height);
    }
    rig.forEach((point, i) => {
      const p = position(point, bend);
      positions[2 * i] = p.x; positions[2 * i + 1] = p.y;
    });
    if (gl) {
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
    gl.bufferSubData(gl.ARRAY_BUFFER, 0, positions);
    gl.clearColor(0, 0, 0, 0);
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.uniform2f(uniforms.u_scale, 2 * size / rect.width, 2 * size / rect.height);
    gl.uniform2f(uniforms.u_origin, 2 * originX / rect.width - 1, 1 - 2 * originY / rect.height);
    gl.drawElements(gl.TRIANGLES, indices.length, gl.UNSIGNED_SHORT, 0);
    } else {
      drawCanvasFallback(rect, size, originX, originY, ratio);
    }
    const end = position(tip, bend);
    handle.style.left = `${originX + end.x * size}px`;
    handle.style.top = `${originY + end.y * size}px`;
    const degrees = Math.round(bend * 180 / Math.PI);
    handle.setAttribute('aria-valuenow', String(degrees));
    handle.setAttribute('aria-valuetext', degrees === 0 ? 'Straight' : `${Math.abs(degrees)} degrees ${degrees < 0 ? 'left' : 'right'}`);
  }

  function drawCanvasFallback(rect, size, originX, originY, ratio) {
    const ctx=context2d, imageWidth=photo.naturalWidth, imageHeight=photo.naturalHeight;
    ctx.setTransform(1,0,0,1,0,0); ctx.clearRect(0,0,canvas.width,canvas.height);
    ctx.setTransform(ratio,0,0,ratio,0,0);
    ctx.drawImage(photo,0,0,imageWidth,neck.y*imageHeight,originX-neck.x*size,originY-neck.y*size,size,neck.y*size);
    for(let i=0;i<indices.length;i+=3){
      if([indices[i],indices[i+1],indices[i+2]].every(index=>uv[index*2+1]<=neck.y))continue;
      const points=[indices[i],indices[i+1],indices[i+2]].map(index=>({sx:uv[index*2]*imageWidth,sy:uv[index*2+1]*imageHeight,x:originX+positions[index*2]*size,y:originY+positions[index*2+1]*size}));
      const [a,b,c]=points, det=(b.sx-a.sx)*(c.sy-a.sy)-(c.sx-a.sx)*(b.sy-a.sy);
      if(Math.abs(det)<0.00001)continue;
      const xx=((b.x-a.x)*(c.sy-a.sy)-(c.x-a.x)*(b.sy-a.sy))/det;
      const xy=((b.y-a.y)*(c.sy-a.sy)-(c.y-a.y)*(b.sy-a.sy))/det;
      const yx=((c.x-a.x)*(b.sx-a.sx)-(b.x-a.x)*(c.sx-a.sx))/det;
      const yy=((c.y-a.y)*(b.sx-a.sx)-(b.y-a.y)*(c.sx-a.sx))/det;
      ctx.save();ctx.setTransform(ratio,0,0,ratio,0,0);ctx.beginPath();
      const cx=(a.x+b.x+c.x)/3,cy=(a.y+b.y+c.y)/3;
      points.forEach((p,j)=>{const length=Math.hypot(p.x-cx,p.y-cy)||1,x=p.x+(p.x-cx)/length*.35,y=p.y+(p.y-cy)/length*.35;j?ctx.lineTo(x,y):ctx.moveTo(x,y);});
      ctx.closePath();ctx.clip();
      ctx.setTransform(xx*ratio,xy*ratio,yx*ratio,yy*ratio,(a.x-xx*a.sx-yx*a.sy)*ratio,(a.y-xy*a.sx-yy*a.sy)*ratio);
      const sx=Math.max(0,Math.min(a.sx,b.sx,c.sx)-1),sy=Math.max(0,Math.min(a.sy,b.sy,c.sy)-1);
      const sw=Math.min(imageWidth-sx,Math.max(a.sx,b.sx,c.sx)-sx+1),sh=Math.min(imageHeight-sy,Math.max(a.sy,b.sy,c.sy)-sy+1);
      ctx.drawImage(photo,sx,sy,sw,sh,sx,sy,sw,sh);ctx.restore();
    }
  }

  function queueDraw() {
    if (pendingFrame !== null) return;
    pendingFrame = requestAnimationFrame(() => { pendingFrame = null; draw(); });
  }
  function angleForTipPoint(x, y) {
    // Beyond horizontal the tip curls inward again. Use both coordinates so
    // dragging upward keeps bending smoothly instead of reversing direction.
    const distance = angle => {
      const end = position(tip, angle);
      return (end.x - x) ** 2 + (end.y - y) ** 2;
    };
    const step = 2 * maxAngle / 60;
    let best = bend, bestDistance = distance(best);
    for (let i = 0; i <= 60; i++) {
      const angle = -maxAngle + i * step, d = distance(angle);
      if (d < bestDistance) { best = angle; bestDistance = d; }
    }
    let low = Math.max(-maxAngle, best - step), high = Math.min(maxAngle, best + step);
    for (let i = 0; i < 18; i++) {
      const left = low + (high - low) / 3, right = high - (high - low) / 3;
      if (distance(left) < distance(right)) high = right;
      else low = left;
    }
    const refined = (low + high) / 2;
    return distance(refined) < bestDistance ? refined : best;
  }
  function release(event) {
    if (!pointer || (event && event.pointerId !== pointer.id)) return;
    const id = pointer.id;
    pointer = null;
    control.classList.remove('is-dragging');
    if (handle.hasPointerCapture(id)) handle.releasePointerCapture(id);
    // Keep the chosen bend until the user moves the tip again or resets it.
  }
  function reset() { release(); bend = 0; draw(); }
  // Only this outlet handle starts a drag. The cup, neck, and background scroll normally.
  handle.addEventListener('pointerdown', event => {
    if (!ready || pointer || !event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
    const { size } = geometry();
    if (!size) return;
    event.preventDefault();
    stage.classList.add('has-tried-flex');
    const end = position(tip, bend);
    pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, tipX: end.x, tipY: end.y, size };
    handle.setPointerCapture(event.pointerId);
    control.classList.add('is-dragging');
    handle.focus({ preventScroll: true });
  });
  handle.addEventListener('pointermove', event => {
    if (!pointer || event.pointerId !== pointer.id) return;
    bend = angleForTipPoint(
      pointer.tipX + (event.clientX - pointer.x) / pointer.size,
      pointer.tipY + (event.clientY - pointer.y) / pointer.size
    );
    queueDraw();
  });
  for (const type of ['pointerup', 'pointercancel', 'lostpointercapture']) handle.addEventListener(type, release);
  control.addEventListener('dragstart', event => event.preventDefault());
  handle.addEventListener('keydown', event => {
    if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Escape', ' ', 'Enter'].includes(event.key)) return;
    event.preventDefault();
    if (pointer) return;
    stage.classList.add('has-tried-flex');
    if (['Escape', ' ', 'Enter'].includes(event.key)) { reset(); return; }
    if (event.key === 'Home') bend = -maxAngle;
    else if (event.key === 'End') bend = maxAngle;
    else bend = clamp(bend + (['ArrowRight', 'ArrowUp'].includes(event.key) ? 1 : -1) * (event.shiftKey ? 15 : 5) * Math.PI / 180, -maxAngle, maxAngle);
    draw();
  });
  resetButton.addEventListener('click', reset);
  window.addEventListener('blur', () => release());
  document.addEventListener('visibilitychange', () => { if (document.hidden) release(); });
  new ResizeObserver(() => { release(); draw(); }).observe(control);
  new IntersectionObserver(([entry]) => {
    stage.classList.toggle('is-demo-visible', entry.isIntersecting);
    if (!entry.isIntersecting) release();
  }, { threshold: 0.25 }).observe(stage);
  canvas.addEventListener('webglcontextlost', event => {
    event.preventDefault(); release(); ready = false;
    stage.classList.remove('is-interactive');
    control.hidden = hint.hidden = resetButton.hidden = true;
  });
  function initialize() {
    if (ready || !photo.naturalWidth) return;
    try { if (gl) gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, photo); }
    catch { return; }
    ready = true; stage.dataset.funnelRenderer = gl ? 'webgl' : 'canvas2d';
    control.hidden = hint.hidden = resetButton.hidden = false;
    stage.classList.add('is-interactive');
    draw();
  }
  photo.addEventListener('load', initialize, { once: true });
  if (photo.complete && photo.naturalWidth) initialize();
})();

(() => {
  const root = document.querySelector('[data-product-page]');
  if (!root) return;
  const data = JSON.parse(root.querySelector('#pdp-data').textContent);
  let selected = data.variants.find(v => v.id === data.initialId) || data.variants[0];
  if (!selected) return;
  const money = new Intl.NumberFormat('en-US', {style:'currency', currency:data.currency || 'USD'});
  const photo = root.querySelector('#pdp-photo');
  const caption = root.querySelector('#pdp-photo-caption');
  let thumbs = [...root.querySelectorAll('[data-gallery-image]')];
  const thumbnailRail = root.querySelector('.pdp-thumbnails');
  const dialog = root.querySelector('.pdp-lightbox');
  const zoomPhoto = dialog.querySelector('img');
  const zoomButton = root.querySelector('.pdp-zoom');
  const notice = root.querySelector('[data-option-notice]');
  let imageRequest = 0, currentPhoto = data.images[0], requestedPhoto = currentPhoto;
  let images = data.images, descriptions = data.imageDescriptions;
  const sized = (src, width = 1100) => { if (src.startsWith('/')) return src; const u = new URL(src, window.location.origin); u.searchParams.set('width', width); return u.href; };
  const galleryIndex = src => images.indexOf(src);
  function syncThumbnails() {
    thumbs.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.galleryImage === currentPhoto)));
  }
  function renderThumbnails() {
    if (!thumbnailRail) return;
    thumbs = images.map((src, i) => {
      const button = document.createElement('button'), img = document.createElement('img');
      button.type = 'button'; button.dataset.galleryImage = src;
      button.setAttribute('aria-label', 'View ' + descriptions[i]);
      button.setAttribute('aria-pressed', 'false');
      img.src = sized(src, 160); img.alt = ''; img.width = img.height = 100; img.loading = 'lazy';
      button.append(img);
      button.addEventListener('click', () => showPhoto(button.dataset.galleryImage));
      return button;
    });
    thumbnailRail.replaceChildren(...thumbs);
  }
  function showPhoto(src, note) {
    const description = descriptions?.[galleryIndex(src)] || data.title;
    requestedPhoto = src;
    const request = ++imageRequest, next = new Image();
    photo.setAttribute('aria-busy', 'true');
    next.onload = () => {
      if (request !== imageRequest) return;
      currentPhoto = src;
      photo.src = sized(src); zoomPhoto.src = src; caption.textContent = note || description;
      photo.alt = zoomPhoto.alt = description;
      photo.removeAttribute('aria-busy');
      const index = galleryIndex(src);
      root.querySelectorAll('[data-image-count]').forEach(item => item.textContent = index < 0 ? 'Selected option' : `${index + 1} / ${images.length}`);
      syncThumbnails();
    };
    next.onerror = () => {
      if (request !== imageRequest) return;
      requestedPhoto = currentPhoto; photo.removeAttribute('aria-busy');
      caption.textContent = 'This photo could not load. Please try another photo.';
    };
    next.src = sized(src);
  }
  function stepPhoto(direction) {
    const index = galleryIndex(requestedPhoto);
    const next = index < 0 ? (direction > 0 ? 0 : images.length - 1) : (index + direction + images.length) % images.length;
    showPhoto(images[next]);
  }
  thumbs.forEach(button => button.addEventListener('click', () => showPhoto(button.dataset.galleryImage)));
  root.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => stepPhoto(Number(button.dataset.galleryStep))));
  function galleryKeys(event) {
    if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault(); stepPhoto(event.key === 'ArrowRight' ? 1 : -1);
  }
  zoomButton.addEventListener('keydown', galleryKeys);
  dialog.addEventListener('keydown', galleryKeys);

  function update(writeUrl = false) {
    root.querySelectorAll('[data-pdp-price]').forEach(item => item.textContent = money.format(selected.price / 100));
    root.querySelectorAll('[data-option-label]').forEach(item => item.textContent = selected.options[Number(item.dataset.optionLabel)]);
    root.querySelectorAll('[data-option-index]').forEach(button => button.setAttribute('aria-pressed', String(selected.options[Number(button.dataset.optionIndex)] === button.dataset.optionValue)));
    root.querySelectorAll('[data-option-select]').forEach(select => select.value = selected.options[Number(select.dataset.optionSelect)]);
    root.querySelectorAll('[data-size-pick]').forEach(button => {
      const active = selected.options[0] === button.dataset.sizePick;
      button.setAttribute('aria-pressed', String(active));
      const status = button.querySelector('[data-size-status]');
      if (status) status.textContent = active ? 'Selected' : '';
    });
    const selection = selected.options.filter(x => x !== 'Default Title').join(' / ') || 'Standard configuration';
    root.querySelectorAll('[data-pdp-selection]').forEach(item => item.textContent = selection);
    root.querySelector('[data-pdp-sku]').textContent = selected.sku ? 'SKU ' + selected.sku : '';
    root.querySelector('[data-variant-id]').value = selected.id;
    root.querySelectorAll('[data-pdp-buy]').forEach(button => button.disabled = !selected.available);
    root.querySelectorAll('[data-pdp-buy-label]').forEach(label => label.textContent = selected.available ? data.labels.add : data.labels.sold);
    const colorGallery = data.galleryByColor?.[selected.options[1]];
    const index = Math.max(0, galleryIndex(requestedPhoto));
    if (colorGallery && images !== colorGallery.images) {
      images = colorGallery.images; descriptions = colorGallery.descriptions;
      renderThumbnails();
    }
    const src = colorGallery ? images[Math.min(index, images.length - 1)] : selected.image || images[0];
    root.querySelector('[data-sticky-photo]').src = sized(selected.image || images[0], 100);
    showPhoto(src, colorGallery ? undefined : selected.image ? 'Product photo · ' + selection : 'Product photo shown.');
    if (writeUrl) {
      const address = new URL(window.location.href); address.searchParams.set('variant', selected.id);
      window.history.replaceState(null, '', address);
    }
  }
  function choose(index, value) {
    const previous = [...selected.options], options = [...previous]; options[index] = value;
    const candidates = data.variants.filter(v => v.options[index] === value);
    const exact = candidates.find(v => v.options.every((option, i) => option === options[i]));
    // Preserve as many of the customer's other choices as a real variant allows.
    const score = v => v.options.reduce((total, option, i) => total + (i !== index && option === previous[i] ? 1 : 0), v.available ? 0.01 : 0);
    selected = exact || candidates.sort((a, b) => score(b) - score(a))[0] || selected;
    const adjusted = selected.options.map((option, i) => i !== index && option !== previous[i] ? `${data.optionNames[i]}: ${option}` : null).filter(Boolean);
    notice.hidden = !adjusted.length;
    notice.textContent = adjusted.length ? `Also updated ${adjusted.join(', ')} to match this option.` : '';
    update(true);
  }
  root.querySelectorAll('[data-option-index]').forEach(button => button.addEventListener('click', () => choose(Number(button.dataset.optionIndex), button.dataset.optionValue)));
  root.querySelectorAll('[data-option-select]').forEach(select => select.addEventListener('change', () => choose(Number(select.dataset.optionSelect), select.value)));
  root.querySelectorAll('[data-size-pick]').forEach(button => button.addEventListener('click', () => {
    choose(0, button.dataset.sizePick);
    const target = root.querySelector('#purchase-options');
    target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
    const matching = [...root.querySelectorAll('[data-option-index]')].find(item => item.dataset.optionIndex === '0' && item.dataset.optionValue === button.dataset.sizePick);
    matching?.focus({preventScroll:true});
  }));
  function restoreVariant() {
    const id = new URLSearchParams(window.location.search).get('variant');
    const replacement = data.variantRedirects?.[id];
    selected = data.variants.find(v => v.id === (replacement || id)) || data.variants.find(v => v.id === data.initialId) || data.variants[0];
    update(Boolean(replacement));
    if (replacement) {
      notice.hidden = false;
      notice.textContent = 'FlexAll is offered in red and blue. Red is selected in your size.';
    }
  }
  renderThumbnails();
  restoreVariant();
  window.addEventListener('popstate', restoreVariant);
  zoomButton.addEventListener('click', () => { zoomPhoto.src = currentPhoto; dialog.showModal(); });
  root.querySelector('.pdp-lightbox-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  const videoDisclosure = root.querySelector('.pdp-video-disclosure');
  videoDisclosure?.addEventListener('toggle', () => {
    if (!videoDisclosure.open) videoDisclosure.querySelector('video')?.pause();
  });
  const sectionLinks = [...root.querySelectorAll('[data-section-link]')];
  const sections = sectionLinks.map(link => root.querySelector(link.getAttribute('href')));
  const jumpNav = root.querySelector('.pdp-jump');
  let activeSection = -1, scrollFrame = 0;
  function updateSection() {
    scrollFrame = 0;
    const threshold = jumpNav.getBoundingClientRect().height + 48;
    let index = 0;
    sections.forEach((section, i) => { if (section.getBoundingClientRect().top <= threshold) index = i; });
    if (index === activeSection) return;
    activeSection = index;
    sectionLinks.forEach((link, i) => {
      if (i === index) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
    const current = sectionLinks[index];
    jumpNav.scrollTo({left:Math.max(0, current.offsetLeft - (jumpNav.clientWidth - current.offsetWidth) / 2), behavior:'auto'});
  }
  function scheduleSection() { if (!scrollFrame) scrollFrame = window.requestAnimationFrame(updateSection); }
  window.addEventListener('scroll', scheduleSection, {passive:true});
  window.addEventListener('resize', scheduleSection);
  // Native anchors keep links shareable; focus follows the same-page destination.
  root.querySelectorAll('a[href^="#"]').forEach(link => link.addEventListener('click', () => {
    const target = root.querySelector(link.getAttribute('href'));
    if (!target) return;
    if (target === videoDisclosure) videoDisclosure.open = true;
    target.setAttribute('tabindex', '-1');
    target.focus({preventScroll:true});
  }));
  const revealLinkedVideo = () => {
    if (window.location.hash === '#product-motion' && videoDisclosure) videoDisclosure.open = true;
    scheduleSection();
  };
  window.addEventListener('hashchange', revealLinkedVideo);
  revealLinkedVideo();
  updateSection();
  if ('IntersectionObserver' in window) {
    const sticky = root.querySelector('[data-sticky-buy]');
    new IntersectionObserver(([entry]) => { sticky.hidden = entry.boundingClientRect.bottom >= 0; }).observe(root.querySelector('[data-buy-zone]'));
  }
})();


(()=>{
 const publish=(name,data)=>{if(window.Shopify?.analytics?.publish){try{window.Shopify.analytics.publish(name,data);}catch{}}};
 let flexTracked=false;
 document.addEventListener('pointerdown',event=>{if(!flexTracked&&event.target.closest('.funnel-handle')){flexTracked=true;publish('tec_funnel_interacted',{page_type:document.querySelector('[data-product-page]')?'product':'home'});}});
 document.addEventListener('click',event=>{
  const link=event.target.closest('a');
  if(link&&link.pathname.startsWith('/collections'))publish('tec_collection_opened',{path:link.pathname,view:new URL(link.href).searchParams.get('view')||'default'});
  const choice=event.target.closest('[data-option-index]');
  if(choice)publish('tec_product_option_selected',{option_index:choice.dataset.optionIndex,value:choice.dataset.optionValue});
  if(link&&link.href.startsWith('mailto:info@tecproducts.com'))publish('tec_partner_email_opened',{location:link.closest('#retailers')?'partner_section':'contact'});
 });
})();
  } catch(e) { console.error(e); }
})();

})();
